const storeVirtualEsl = {
    path: "storeVirtualEsl",
    name: "storeVirtualEsl",
    component: () => import('@/layout'),
    redirect: 'noRedirect',
    meta: {
        code: 'virtualEsl',
        icon: 'HSIconfont hs-icon-a-virtualesl',
        showRealm: ['NORMAL']
    },
    children: [
        {
            path: 'storeVirtualEslManagement',
            name: 'storeVirtualEslManagement',
            component: () => import('@/views/storeVirtualEslManagement'),
            meta: { code: 'virtualEsl:virtualEsl' }

        }
    ]
};

export default storeVirtualEsl;
